import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { CrudService } from '../../../crud/crud.service';
import { environment } from '../../../../environments/environment';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { HttpClient, HttpHeaders, HttpResponse  } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map} from 'rxjs/operators';

import * as moment from 'moment';
import jsPDF from 'jspdf'; import autoTable from 'jspdf-autotable'; import * as jQuery from 'jquery';

@Component({
  selector: "app-facturacion",
  templateUrl: "./formulario.component.html"
})
export class FacturacionComponent implements OnInit{


   esFacturaGlobal = false;

  periodicidad_global: string = '';
  mes_global: string = '';
  anio_global: string = '';

  meses = [
    { value: '01', label: 'Enero' },
    { value: '02', label: 'Febrero' },
    { value: '03', label: 'Marzo' },
    { value: '04', label: 'Abril' },
    { value: '05', label: 'Mayo' },
    { value: '06', label: 'Junio' },
    { value: '07', label: 'Julio' },
    { value: '08', label: 'Agosto' },
    { value: '09', label: 'Septiembre' },
    { value: '10', label: 'Octubre' },
    { value: '11', label: 'Noviembre' },
    { value: '12', label: 'Diciembre' },
    // ... etc.
  ];

  anios = [2023, 2024, 2025, 2026];

  dato: FormGroup;
  facturacion;
  tamano = document.body.clientHeight;

  error_timbre = false;
  valido = false;
  cargando = false;
  error_busqueda = false;
  sin_resultado = "";
  errores = [];
  busqueda = "";
  auto = 0;
  todas_ventas = false;
  tipo = "";
  activarRfc = false;
  activarUso = false;
  seleccionar_iva = true;

  complemento = true;

  date = new Date();
  MinDate = new Date(this.date.getFullYear(), this.date.getMonth() - 1, 1);

  fecha_desde = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 1);
  fecha_actual = new Date(
    this.date.getFullYear(),
    this.date.getMonth() + 1,
    this.date.getDate()
  );

  desde =
    this.date.getFullYear() + "-" + (this.date.getMonth() + 1) + "-" + "1";
  // hasta =
  //   this.date.getFullYear() +
  //   "-" +
  //   (this.date.getMonth() + 1) +
  //   "-" +
  //   this.date.getDate();

  codigo = "";
  cliente = "";
  facturas_mes = [];
  requiere_factura = 1;

  ventas_facturar = [];
  ventas_mes_facturar = [];
  desglosar_impuestos = true;
  con_impuesto = true;
  VERSION_CFDI = environment.VERSION_CFDI;
  CFDI_PATH = environment.CFDI_PATH;

  empresa = localStorage.getItem("empresa");
  sucursal = localStorage.getItem("sucursal");
  configuracion = JSON.parse(localStorage.getItem("configuracion"));
  public clientes_term: string = `${environment.API_URL}/clientes-auto?term=:keyword&empresa=${this.empresa}`;
  constructor(
    private crudService: CrudService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private http: HttpClient,
    private _sanitizer: DomSanitizer
  ) {}

  observableSource = (keyword: any): Observable<any[]> => {
    
    let url: string =  `${environment.API_URL}/clientes-auto?term=${keyword}&empresa=${this.empresa}`;
    if (keyword) {
      return this.http.get(url).pipe(map((response: HttpResponse<any>) => {
        let data: any = response;
        return data.data;
      }));
        
    } else {
      return Observable.bind([]);
    }
  }

  ngOnInit() {
    this.dato = this.fb.group({
      id: [""]
    });
    this.facturacion = {
      Version: this.VERSION_CFDI,
      Serie: this.configuracion.sucursal.facturacion.serie,
      Folio: "",
      Fecha: moment
        .utc(
          moment(
            new Date(
              this.date.getTime() - this.date.getTimezoneOffset() * 60000
            )
          )
        )
        .format(),
      Sello: "",
      NoCertificado: "",
      Certificado: "",
      SubTotal: 0,
      Moneda: this.configuracion.sucursal.moneda,
      Total: 0,
      TotalLetra: "",
      TipoDeComprobante: "I",
      FormaPago: "",
      MetodoPago: "",
      CondicionesDePago: "Contado",
      Descuento: 0,
      LugarExpedicion: this.configuracion.sucursal.facturacion.lugar_expedicion,

      CfdiRelacionados: {
        TipoRelacion: "",
        CfdiRelacionado: [
          {
            UUID: ""
          }
        ]
      },
      Emisor: {
        Rfc: this.configuracion.sucursal.facturacion.rfc,
        Nombre: this.configuracion.sucursal.facturacion.razon_social,
        RegimenFiscal: this.configuracion.sucursal.facturacion.regimen_fiscal
      },
      Receptor: {
        Rfc: "",
        Nombre: "",
        UsoCFDI: "",
        RegimenFiscalReceptor : "",
        DomicilioFiscalReceptor : ""
      },
      Conceptos: {
        Concepto: []
      },

      Impuestos: {
        TotalImpuestosTrasladados: 0,
        TotalImpuestosRetenidos: 0,
        Traslados: [],
        Retenciones: []
      },

      Complemento: {
        TimbreFiscalDigital: {
          FechaTimbrado: "",
          UUID: "",
          NoCertificadoSAT: "",
          SelloCFD: "",
          SelloSAT: "",
          CadenaOriginal: "",
          qr: ""
        }
      }
    };
    document.getElementById("catalogos").click();
  }

  autocompleListFormatter = (data: any) => {
    if (this.auto == 0) {
      $("ngui-auto-complete").attr(
        "style",
        $("ngui-auto-complete").attr("style") + "z-index:999; width:1x;"
      );
    }
    let html = `
    <div class="card" >
      <div class="card-content">
        <div class="media">
          <div class="media-content">
            <h4 style="font-size:1.5em; color:#292929; font-weight: 600;">
              ${data.nombre}
              <small style="font-size: .5em; font-style: italic;">
                ${data.email}
              </small>
            </h4>
            <h6>
              <strong>Razón social: </strong> ${data.razon_social}
              <strong>RFC: </strong> ${data.rfc}
            </h6>
            <h6 class="has-text-success">Dirección:
                ${data.colonia} #${data.numero_exterior} CP: ${
      data.codigo_postal
    },
                ${data.colonia}, ${data.localidad}

            </h6>
          </div>
        </div>
      </div>
    </div>`;
    this.auto++;
    return this._sanitizer.bypassSecurityTrustHtml(html);
  };
  personas_rfcs_seleccionado = {};
  select_cliente_autocomplete(data) {
    this.cargando = true;
    this.auto = 0;

    this.facturacion.Receptor.Rfc = data.rfc;
    this.facturacion.Receptor.Nombre = data.razon_social != "" ? data.razon_social : data.nombre;
    this.facturacion.Receptor.UsoCFDI = "G01";

    this.facturacion.Receptor.RegimenFiscalReceptor = data.tipos_regimenes_fiscales_id;
    this.facturacion.Receptor.DomicilioFiscalReceptor = data.codigo_postal;

    this.personas_rfcs_seleccionado = data;

    setTimeout(() => {
      if (this.facturacion.Conceptos.Concepto.length > 0) {
        this.valido = true;
      }
      this.cargando = false;
    }, 200);
  }

  buscar_venta() {
    this.valido = false;
    this.cargando = true;
    this.ventas_facturar = [];
    this.facturacion.Conceptos.Concepto = [];
    this.facturacion.Impuestos = {
      Traslados: [],
      Retenciones: []
    };
    this.crudService
      .lista({pagina: 0, limite: 0}, "venta-facturacion?codigo=" + this.codigo)
      .subscribe(
        resultado => {
          this.cargando = false;
          // se encontro resultado
          if (resultado.status === 200) {
            if (this.facturacion.Receptor.Rfc === "") {
              if (resultado.data.personas.personas_rfcs.length) {
                this.facturacion.Receptor.Rfc = resultado.data.personas.personas_rfcs[0].rfc;
                this.facturacion.Receptor.Nombre = resultado.data.personas.personas_rfcs[0].razon_social;
                this.facturacion.Receptor.UsoCFDI = "G01";

                this.facturacion.Receptor.RegimenFiscalReceptor = resultado.data.personas.personas_rfcs[0].tipos_regimenes_fiscales_id;

                this.facturacion.Receptor.DomicilioFiscalReceptor = resultado.data.personas.personas_rfcs[0].codigo_postal;

                this.personas_rfcs_seleccionado = resultado.data.personas.personas_rfcs[0];
                
                this.valido = true;
              }
            } else {
              this.valido = true;
            }
            this.ventas_facturar.push(resultado.data.id);

            let forma_pago = resultado.data.pagos[0].tipos_formas_pagos_id;

            // datos generales
            this.facturacion.Serie = this.configuracion.sucursal.facturacion.serie;
            this.facturacion.Folio = resultado.data.folio;
            this.facturacion.Fecha = moment
              .utc(
                moment(
                  moment
                    .utc(
                      moment(
                        new Date(
                          this.date.getTime() -
                            this.date.getTimezoneOffset() * 60000
                        )
                      )
                    )
                    .format()
                )
              )
              .format();
            this.facturacion.FormaPago = forma_pago;
            this.facturacion.MetodoPago =
              resultado.data.pagos[0].tipos_metodos_pagos_id;

            let impuestos = this.configuracion.sucursal.impuestos;

            let suma_impuesto_rete = [];
            let suma_impuesto_tras = [];
            let suma_descuento = 0;
            let subtotal = 0;
            let total_descuento = 0;
            let total = 0;
            // conceptos
            resultado.data.movimientos_articulos.forEach(elem => {
              // importe del articulo
              let precio_unitario = 0;
              // let importe = parseFloat(elem.importe);
              let importe = parseFloat(elem.precio_con_descuentos);
              let impuesto_incluido = {
                Traslados: [],
                Retenciones: []
              };
              elem.descuento = 0;
              // ver si se desglosa el impuesto, en caso contrario se agrega
              let desc = parseFloat(elem.descuento) / 100;
              let descuento = 0;
              if (this.desglosar_impuestos) {
                let desglosarT = 0; let desglosarR = 0;
                impuestos.traslados.forEach(el => {
                  let impp = importe - importe / (1 + parseFloat(el.cuota));
                  desglosarT += this.RedondeaDosDecimal(impp);
                });

                importe = this.RedondeaDosDecimal((importe - desglosarT) );
                precio_unitario = this.RedondeaDosDecimal((importe / elem.cantidad));

                impuestos.retenciones.forEach(el => {
                  let impp = importe - importe / (1 + parseFloat(el.cuota));
                  desglosarR += this.RedondeaDosDecimal(impp);
                });

                descuento = this.RedondeaDosDecimal(importe * desc );
                suma_descuento += this.RedondeaDosDecimal(descuento );
              } else {
                let sumarT = 0; let sumarR = 0;
                importe = this.RedondeaDosDecimal((importe + sumarT) );
                descuento = this.RedondeaDosDecimal(importe * desc );
                precio_unitario = this.RedondeaDosDecimal((importe / elem.cantidad) );

                suma_descuento += descuento;
                impuestos.traslados.forEach(el => {
                  let summ = importe - importe / (1 + this.RedondeaDosDecimal(el.cuota));
                  sumarT += this.RedondeaDosDecimal(summ);
                });

                impuestos.retenciones.forEach(el => {
                  let summ = importe - importe / (1 + this.RedondeaDosDecimal(el.cuota));
                  sumarR += this.RedondeaDosDecimal(summ);
                });
              }
              descuento = this.RedondeaDosDecimal(importe * desc );
              impuestos.traslados.forEach(el => {
                if (!suma_impuesto_tras[el.clave]) {
                  suma_impuesto_tras[el.clave] = 0;
                }
                let importe_impuesto =
                  this.RedondeaDosDecimal((importe - descuento) );
                let impp =
                  this.RedondeaDosDecimal(importe_impuesto * this.RedondeaDosDecimal(el.cuota) )

                suma_impuesto_tras[el.clave] += this.RedondeaDosDecimal(impp );
                impuesto_incluido.Traslados.push({
                  Traslado: {
                    Base: importe_impuesto,
                    Impuesto: el.clave,
                    TipoFactor: el.factor,
                    TasaOCuota: el.cuota,
                    Importe: impp
                  }
                });
              });

              impuestos.retenciones.forEach(el => {
                if (!suma_impuesto_rete[el.clave]) {
                  suma_impuesto_rete[el.clave] = 0;
                }
                let importe_impuesto =
                  this.RedondeaDosDecimal((importe - descuento) );
                let impp =
                  this.RedondeaDosDecimal(importe_impuesto * parseFloat(el.cuota) )

                suma_impuesto_rete[el.clave] += this.RedondeaDosDecimal(impp );
                impuesto_incluido.Retenciones.push({
                  Retencion: {
                    Base: importe_impuesto,
                    Impuesto: el.clave,
                    TipoFactor: el.factor,
                    TasaOCuota: el.cuota,
                    Importe: impp
                  }
                });
              });
              total_descuento += descuento;
              subtotal += importe;

              this.facturacion.Conceptos.Concepto.push({
                ClaveProdServ: elem.articulos.clave_prod_serv,
                ClaveUnidad: elem.articulos.unidades_medidas.clave,
                NoIdentificacion: elem.articulos.sku,
                Cantidad: elem.cantidad,
                Unidad: elem.articulos.unidades_medidas.nombre,
                Descripcion: elem.articulos.nombre.trim(),
                ValorUnitario: this.RedondeaDosDecimal(precio_unitario ),
                Importe: this.RedondeaDosDecimal(importe ),
                Impuestos: impuesto_incluido,
                ComplementoConcepto: {
                  version: "1.0",
                  nombreAlumno:
                    resultado.data.personas.nombre +
                    " " +
                    resultado.data.personas.apellido_paterno +
                    " " +
                    resultado.data.personas.apellido_materno,
                  CURP: resultado.data.personas.curp,
                  nivelEducativo:
                    resultado.data.personas.carrera.nivel_educativo,
                  autRVOE: resultado.data.personas.carrera.rvoe
                },
              });

              if (this.facturacion.TipoDeComprobante == 'I') {
                this.facturacion.Conceptos.Concepto[this.facturacion.Conceptos.Concepto.length - 1].Descuento = this.RedondeaDosDecimal(descuento);
              }

            });

            let total_impuesto_tras = 0;
            let total_impuesto_rete = 0;

            impuestos.traslados.forEach(el => {
              total_impuesto_tras +=
                this.RedondeaDosDecimal(suma_impuesto_tras[el.clave] );
              this.facturacion.Impuestos.Traslados.push({
                Traslado: {
                  Impuesto: el.clave,
                  TipoFactor: el.factor,
                  TasaOCuota: el.cuota,
                  Importe: this.RedondeaDosDecimal(suma_impuesto_tras[el.clave] )
                }
              });
            });
            impuestos.retenciones.forEach(el => {
              total_impuesto_rete +=
                this.RedondeaDosDecimal(suma_impuesto_rete[el.clave] );
              this.facturacion.Impuestos.Retenciones.push({
                Retencion: {
                  Impuesto: el.clave,
                  TipoFactor: el.factor,
                  TasaOCuota: el.cuota,
                  Importe: this.RedondeaDosDecimal(suma_impuesto_rete[el.clave] )
                }
              });
            });

            this.facturacion.Impuestos.TotalImpuestosTrasladados = this.RedondeaDosDecimal(total_impuesto_tras );
            this.facturacion.Impuestos.TotalImpuestosRetenidos = this.RedondeaDosDecimal(total_impuesto_rete );

            let T_Total = subtotal - total_descuento + (total_impuesto_tras - total_impuesto_rete);

            this.facturacion.SubTotal = this.RedondeaDosDecimal(subtotal );
            if (this.facturacion.TipoDeComprobante == 'I') {
              this.facturacion.Descuento = this.RedondeaDosDecimal(total_descuento );
            }
            this.facturacion.Total = this.RedondeaDosDecimal(T_Total );
          } else {
            this.sin_resultado = resultado.messages;
            setTimeout(() => {
              this.sin_resultado = "";
            }, 3500);
          }

          this.error_busqueda = false;
        },
        error => {
          this.cargando = false;
          this.valido = false;
          this.error_busqueda = true;
          setTimeout(() => {
            this.error_busqueda = false;
          }, 3500);
        }
      );
  }

  ventas_mes() {
    this.valido = false;
    this.cargando = true;
    this.facturas_mes = [];
    this.crudService
      .lista({pagina: 0, limite: 0}, "venta-mes?desde=" + this.desde + "&tipo=" + this.tipo + "&requiere_factura=" + this.requiere_factura)
      .subscribe(
        resultado => {
          this.cargando = false;
          if (resultado.status === 200) {
            this.facturas_mes = resultado.data;
          } else {
            this.sin_resultado = resultado.messages;
            setTimeout(() => {
              this.sin_resultado = "";
            }, 3500);
          }
          this.error_busqueda = false;
        },
        error => {
          this.cargando = false;
          this.valido = false;
          this.error_busqueda = true;
          setTimeout(() => {
            this.error_busqueda = false;
          }, 3500);
        }
      );
  }
  cambiar_impuesto() {
    this.con_impuesto = !this.con_impuesto;
    this.recalcular_impuesto();
  }
  cambiar_desglose() {
    this.desglosar_impuestos = !this.desglosar_impuestos;
    this.recalcular_impuesto();
  }
  recalcular_impuesto() {
    this.facturacion.Impuestos = {
      Traslados: [],
      Retenciones: []
    };
    let impuestos = this.configuracion.sucursal.impuestos;
    let posicion = 0;
    let total_total_impuesto_tras = 0;
    let total_total_impuesto_rete = 0;
    let total_subtotal = 0;
    let total_total_descuento = 0;
    let suma_impuesto_rete = [];
    let suma_impuesto_tras = [];
    let suma_descuento = 0;
    // conceptos
    if (this.facturacion.Conceptos.Concepto) {
      this.facturacion.Conceptos.Concepto.forEach(elem => {
        // importe del articulo
        let importe = elem.Importe;
        let impuesto_incluido = {
          Traslados: [],
          Retenciones: []
        };
        elem.Descuento = 0;
        // ver si se desglosa el impuesto, en caso contrario se agrega
        let precio_unitario = 0;

        if (this.desglosar_impuestos) {
          let desglosarT = 0; let desglosarR = 0;
          impuestos.traslados.forEach(el => {
            desglosarT += importe - importe / (1 + parseFloat(el.cuota));
          });

          importe = importe - desglosarT;
          precio_unitario = elem.ValorUnitario - desglosarT;

          impuestos.retenciones.forEach(el => {
            desglosarR += importe - importe / (1 + parseFloat(el.cuota));
          });

        } else {
          let sumarT = 0; let sumarR = 0;
          impuestos.traslados.forEach(el => {
            sumarT += importe - importe / (1 + parseFloat(el.cuota));
          });

          importe = importe + sumarT;
          precio_unitario = elem.ValorUnitario + sumarT;

          impuestos.retenciones.forEach(el => {
            sumarR += importe - importe / (1 + parseFloat(el.cuota));
          });

          importe = importe + sumarR;
          precio_unitario = elem.ValorUnitario + sumarR;
        }

        let descuento = parseFloat(elem.Descuento);

        suma_descuento += descuento;
        importe = importe - descuento;

        if (this.con_impuesto) {
          impuesto_incluido.Traslados = [];
          impuestos.traslados.forEach(el => {
            if (!suma_impuesto_tras[el.clave]) {
              suma_impuesto_tras[el.clave] = 0;
            }
            suma_impuesto_tras[el.clave] += importe * parseFloat(el.cuota);
            impuesto_incluido.Traslados.push({
              Traslado: {
                Base: this.RedondeaDosDecimal(importe ),
                Impuesto: el.clave,
                TipoFactor: el.factor,
                TasaOCuota: el.cuota,
                Importe: importe * parseFloat(el.cuota)
              }
            });
          });

          impuesto_incluido.Retenciones = [];
          impuestos.retenciones.forEach(el => {
            if (!suma_impuesto_rete[el.clave]) {
              suma_impuesto_rete[el.clave] = 0;
            }
            suma_impuesto_rete[el.clave] += importe * parseFloat(el.cuota);
            impuesto_incluido.Retenciones.push({
              Retencion: {
                Base: this.RedondeaDosDecimal(importe ),
                Impuesto: el.clave,
                TipoFactor: el.factor,
                TasaOCuota: el.cuota,
                Importe: importe * parseFloat(el.cuota)
              }
            });
          });
        }

        this.facturacion.Conceptos.Concepto[posicion] = {
          ClaveProdServ: elem.ClaveProdServ,
          ClaveUnidad: elem.ClaveUnidad,
          NoIdentificacion: elem.NoIdentificacion,
          Cantidad: elem.Cantidad,
          Unidad: elem.Unidad,
          Descripcion: elem.Descripcion,
          ValorUnitario: precio_unitario,
          Importe: elem.Cantidad * elem.ValorUnitario
        };

        if (this.facturacion.TipoDeComprobante == 'I') {
          this.facturacion.Conceptos.Concepto[posicion].Descuento = descuento;
        }

        total_subtotal += elem.Cantidad * elem.ValorUnitario - descuento;

        if (this.con_impuesto) {
          this.facturacion.Conceptos.Concepto[
            posicion
          ].Impuestos = impuesto_incluido;
        }
        posicion++;
      });

      if (this.con_impuesto) {
        impuestos.traslados.forEach(el => {
          total_total_impuesto_tras += suma_impuesto_tras[el.clave];
          this.facturacion.Impuestos.Traslados.push({
            Traslado: {
              Impuesto: el.clave,
              TipoFactor: el.factor,
              TasaOCuota: el.cuota,
              Importe: suma_impuesto_tras[el.clave]
            }
          });
        });
        impuestos.retenciones.forEach(el => {
          total_total_impuesto_rete += suma_impuesto_rete[el.clave];
          this.facturacion.Impuestos.Retenciones.push({
            Retencion: {
              Impuesto: el.clave,
              TipoFactor: el.factor,
              TasaOCuota: el.cuota,
              Importe: suma_impuesto_rete[el.clave]
            }
          });
        });

        this.facturacion.Impuestos.TotalImpuestosTrasladados = this.RedondeaDosDecimal(total_total_impuesto_tras );
        this.facturacion.Impuestos.TotalImpuestosRetenidos = this.RedondeaDosDecimal(total_total_impuesto_rete );
      }

      let gran_total = total_subtotal - suma_descuento + (total_total_impuesto_tras - total_total_impuesto_rete);

      this.facturacion.SubTotal = this.RedondeaDosDecimal(total_subtotal );
      if (this.facturacion.TipoDeComprobante == 'I') {
        this.facturacion.Descuento = this.RedondeaDosDecimal(suma_descuento);
      }

      this.facturacion.Total = this.RedondeaDosDecimal(gran_total );
    }
  }
  // agregar todos al objeto para facturar
  agregar_venta_mes() {
    this.ventas_mes_facturar = [];
    this.todas_ventas = !this.todas_ventas;
    if (this.todas_ventas) {
      this.facturas_mes.forEach(element => {
        this.ventas_mes_facturar.push(element.id);
      });
    }
  }
  // agregar item al objeto para facturar
  agregar_venta(item) {
    if (this.ventas_mes_facturar.indexOf(item.id) > -1) {
      this.ventas_mes_facturar.splice(
        this.ventas_mes_facturar.indexOf(item.id),
        1
      );
    } else {
      this.ventas_mes_facturar.push(item.id);
    }
  }
  // se agrega a la lista todas las facturas seleccionadas del mes
  agregar_facturacion() {
    this.valido = false;
    this.cargando = true;
    this.ventas_facturar = [];
    this.facturacion.Conceptos.Concepto = [];
    this.facturacion.Impuestos = {
      Traslados: [],
      Retenciones: []
    };
    let ventas_m = { "datos": this.ventas_mes_facturar};
    let json: any = ventas_m;
    
    this.crudService
      .crear(json, "venta-facturacion-mes")
      .subscribe(
        resultado => {
          this.cargando = false;
          // se encontro resultado
          if (resultado.status === 200) {
            let suma_impuesto_rete = [];
            let suma_impuesto_tras = [];
            let total_total_impuesto_tras = 0;
            let total_total_impuesto_rete = 0;
            let total_subtotal = 0;
            let total_total_descuento = 0;
            resultado.data.forEach(element => {
              this.ventas_facturar.push(element.id);
              let impuestos = this.configuracion.sucursal.impuestos;

              let suma_descuento = 0;
              let subtotal = 0;
              let total_descuento = 0;
              let total = 0;
              // conceptos
              element.movimientos_articulos.forEach(elem => {
                // importe del articulo
                let precio_unitario = 0;
                //let importe = parseFloat(elem.importe);
                let importe = parseFloat(elem.precio_con_descuentos);
                let impuesto_incluido = {
                  Traslados: [],
                  Retenciones: []
                };
                elem.descuento = 0;
                // ver si se desglosa el impuesto, en caso contrario se agrega

                let desc = parseFloat(elem.descuento) / 100;
                let descuento = 0; let desglosarT = 0; let desglosarR = 0;
                if (this.desglosar_impuestos) {

                  impuestos.traslados.forEach(el => {
                    let impp = importe - importe / (1 + parseFloat(el.cuota));
                    desglosarT += this.RedondeaDosDecimal(impp );
                  });
                  importe = this.RedondeaDosDecimal((importe - desglosarT));
                  precio_unitario = this.RedondeaDosDecimal((importe / parseFloat(elem.cantidad)))

                  impuestos.retenciones.forEach(el => {
                    let impp = importe - importe / (1 + parseFloat(el.cuota));
                    desglosarR += this.RedondeaDosDecimal(impp );
                  });

                  descuento = this.RedondeaDosDecimal(importe * desc );
                  suma_descuento += descuento;
                } else {
                  let sumar = 0;
                  importe = this.RedondeaDosDecimal((importe + sumar) );
                  descuento = this.RedondeaDosDecimal(importe * desc );
                  precio_unitario = this.RedondeaDosDecimal((importe / parseFloat(elem.cantidad)) )

                  suma_descuento += descuento;
                  impuestos.traslados.forEach(el => {
                    let impp = importe - importe / (1 + parseFloat(el.cuota));
                    sumar += this.RedondeaDosDecimal(impp );
                  });

                  impuestos.retenciones.forEach(el => {
                    let impp = importe - importe / (1 + this.RedondeaDosDecimal(el.cuota));
                    sumar += this.RedondeaDosDecimal(impp );
                  });
                }

                descuento = this.RedondeaDosDecimal(importe * desc );

                impuestos.traslados.forEach(el => {
                  if (!suma_impuesto_tras[el.clave]) {
                    suma_impuesto_tras[el.clave] = 0;
                  }
                  let importe_impuesto =
                    this.RedondeaDosDecimal((importe - descuento) );
                  let impp =
                    this.RedondeaDosDecimal(importe_impuesto * parseFloat(el.cuota) )

                  suma_impuesto_tras[el.clave] += this.RedondeaDosDecimal(impp );
                  impuesto_incluido.Traslados.push({
                    Traslado: {
                      Base: importe_impuesto,
                      Impuesto: el.clave,
                      TipoFactor: el.factor,
                      TasaOCuota: el.cuota,
                      Importe: impp
                    }
                  });
                });

                impuestos.retenciones.forEach(el => {
                  if (!suma_impuesto_rete[el.clave]) {
                    suma_impuesto_rete[el.clave] = 0;
                  }
                  let importe_impuesto =
                    this.RedondeaDosDecimal((importe - descuento) );
                  let impp =
                    this.RedondeaDosDecimal(importe_impuesto * parseFloat(el.cuota) )

                  suma_impuesto_rete[el.clave] += this.RedondeaDosDecimal(impp );
                  impuesto_incluido.Retenciones.push({
                    Retencion: {
                      Base: importe_impuesto,
                      Impuesto: el.clave,
                      TipoFactor: el.factor,
                      TasaOCuota: el.cuota,
                      Importe: impp
                    }
                  });
                });
                total_descuento += descuento;
                subtotal += importe;

                this.facturacion.Conceptos.Concepto.push({
                  ClaveProdServ: elem.articulos.clave_prod_serv,
                  ClaveUnidad: elem.articulos.unidades_medidas.clave,
                  NoIdentificacion: elem.articulos.sku,
                  Cantidad: elem.cantidad,
                  Unidad: elem.articulos.unidades_medidas.nombre,
                  Descripcion: elem.articulos.nombre.trim(),
                  ValorUnitario: this.RedondeaDosDecimal(precio_unitario ),
                  Descuento: this.RedondeaDosDecimal(descuento ),
                  Importe: this.RedondeaDosDecimal(importe ),
                  Impuestos: impuesto_incluido,
                  ComplementoConcepto: {
                    version: "1.0",
                    nombreAlumno:
                      resultado.data[0].personas.nombre +
                      " " +
                      resultado.data[0].personas.apellido_paterno +
                      " " +
                      resultado.data[0].personas.apellido_materno,
                    CURP: resultado.data[0].personas.curp,
                    nivelEducativo:
                      resultado.data[0].personas.carrera.nivel_educativo,
                    autRVOE: resultado.data[0].personas.carrera.rvoe
                  },
                });

                if (this.facturacion.TipoDeComprobante == 'I') {
                  this.facturacion.Conceptos.Concepto[this.facturacion.Conceptos.Concepto.length - 1].Descuento = this.RedondeaDosDecimal(descuento);
                }
              });
              let total_impuesto_tras = 0;
              let total_impuesto_rete = 0;

              impuestos.traslados.forEach(el => {
                total_impuesto_tras += this.RedondeaDosDecimal(suma_impuesto_tras[el.clave] );
              });

              impuestos.retenciones.forEach(el => {
                total_impuesto_rete += this.RedondeaDosDecimal(suma_impuesto_rete[el.clave] );
              });

              total_subtotal += subtotal;
              total_total_descuento += total_descuento;
            });

            let forma_pago = resultado.data[0].pagos[0].tipos_formas_pagos_id;

            // datos generales
            this.facturacion.Serie = this.configuracion.sucursal.facturacion.serie;
            this.facturacion.Folio = resultado.data[0].folio;
            this.facturacion.Fecha = moment
              .utc(
                moment(
                  moment
                    .utc(
                      moment(
                        new Date(
                          this.date.getTime() -
                            this.date.getTimezoneOffset() * 60000
                        )
                      )
                    )
                    .format()
                )
              )
              .format();
            this.facturacion.FormaPago = forma_pago;
            this.facturacion.MetodoPago =
              resultado.data[0].pagos[0].tipos_metodos_pagos_id;

            // impuestos
            let impuestos = this.configuracion.sucursal.impuestos;
            let total_impuesto_tras = 0;
            let total_impuesto_rete = 0;

            impuestos.traslados.forEach(el => {
              total_total_impuesto_tras += suma_impuesto_tras[el.clave];
              this.facturacion.Impuestos.Traslados.push({
                Traslado: {
                  Impuesto: el.clave,
                  TipoFactor: el.factor,
                  TasaOCuota: el.cuota,
                  Importe: suma_impuesto_tras[el.clave]
                }
              });
            });

            impuestos.retenciones.forEach(el => {
              total_total_impuesto_rete += suma_impuesto_rete[el.clave];
              this.facturacion.Impuestos.Retenciones.push({
                Retencion: {
                  Impuesto: el.clave,
                  TipoFactor: el.factor,
                  TasaOCuota: el.cuota,
                  Importe: suma_impuesto_rete[el.clave]
                }
              });
            });
            this.facturacion.Impuestos.TotalImpuestosTrasladados = this.RedondeaDosDecimal(total_total_impuesto_tras );
            this.facturacion.Impuestos.TotalImpuestosRetenidos = this.RedondeaDosDecimal(total_total_impuesto_rete );

            let gran_total = total_subtotal - total_total_descuento + (total_total_impuesto_tras - total_total_impuesto_rete);

            this.facturacion.SubTotal = this.RedondeaDosDecimal(total_subtotal );
            if (this.facturacion.TipoDeComprobante == 'I') {
              this.facturacion.Descuento = this.RedondeaDosDecimal(total_total_descuento );
            }
            this.facturacion.Total = this.RedondeaDosDecimal(gran_total);
            document.getElementById("close_ventas_colas")?.click();
          } else {
            this.sin_resultado = resultado.messages;
            setTimeout(() => {
              this.sin_resultado = "";
            }, 3500);
          }

          this.error_busqueda = false;
        },
        error => {
          this.cargando = false;
          this.valido = false;
          this.error_busqueda = true;
          setTimeout(() => {
            this.error_busqueda = false;
          }, 3500);
        }
      );
  }
  RedondeaDosDecimal(num) {
    return parseFloat((Math.round(num * 100) / 100).toFixed(2));
  }

  timbrar() {
    document.getElementById("confirmarTimbrar").classList.remove("is-active");
    this.cargando = true;
    let json: any = this.facturacion;
    this.error_timbre = false;
    this.crudService.crear(json, this.CFDI_PATH + "/api/v1/markado").subscribe(
      resultado => {
        this.cargando = false;
        if (resultado.status === 201) {
          // datos de respuesta del pac
          let resupuesta = resultado.data;
          // obtener los datos de regreso de la api para la factura
          this.facturacion = resultado.json;

          // guardar la factura local para consultas posteriores
          this.guardar_factura(resultado);
          setTimeout(() => {
            document.getElementById("imprimir_pdf").click();
          }, 250);
        } else {
          if(resultado.status == 505){
            this.facturacion.Folio = this.facturacion.Folio + 1;
            this.timbrar();
          } else if (resultado.messages.errores) {
            this.errores = resultado.messages.errores;
            setTimeout(() => {
              this.errores = [];
            }, 3500 * this.errores.length);
          } else {
            this.sin_resultado = resultado.messages;
            setTimeout(() => {
              this.sin_resultado = "";
            }, 3000);
          }
        }
      },
      error => {
        this.cargando = false;
        this.error_timbre = true;
        setTimeout(() => {
          this.error_timbre = false;
        }, 3500);
      }
    );
  }

  guardar_factura(respuesta) {
    respuesta["ventas"] = this.ventas_facturar;
    this.crudService
      .crear(respuesta, "factura")
      .subscribe(resultado => {}, error => {});
  }

  quita_poner_iva(item) {
    item.iva = !item.iva;

    if (item.iva) {
      let suma_impuesto_rete = [];
      let suma_impuesto_tras = [];

      let impuesto_incluido = {
        Traslados: [],
        Retenciones: []
      };

      let impuestos = this.configuracion.sucursal.impuestos;
      let desglosar = 0;
      let imp_des = 0;

      impuestos.traslados.forEach(el => {
        if(el.cuota > 0){
          let impp = item.precio_unitario - item.precio_unitario / (1 + parseFloat(el.cuota));
          desglosar += parseFloat(impp.toFixed(2));
          imp_des += parseFloat(el.cuota);
        }
      });

      impuestos.retenciones.forEach(el => {
        let impp =
          item.precio_unitario -
          item.precio_unitario / (1 + parseFloat(el.cuota));
        desglosar += parseFloat(impp.toFixed(2));
        imp_des += parseFloat(el.cuota);
      });

      impuestos.traslados.forEach(el => {
        if (!suma_impuesto_tras[el.clave]) {
          suma_impuesto_tras[el.clave] = 0;
        }
        let importe_impuesto = parseFloat(
          (item.importe - item.descuento).toFixed(2)
        );
        let impp = parseFloat(
          (importe_impuesto * parseFloat(el.cuota)).toFixed(2)
        );
        suma_impuesto_tras[el.clave] += parseFloat(impp.toFixed(2));
        let traslado : any = {
          Base: importe_impuesto,
          Impuesto: el.clave,
          TipoFactor: el.factor,
          TasaOCuota : el.cuota,
          Importe : impp.toFixed(2),
        }
        impuesto_incluido.Traslados.push({
          Traslado: traslado
        });
      });

      impuestos.retenciones.forEach(el => {
        if (!suma_impuesto_rete[el.clave]) {
          suma_impuesto_rete[el.clave] = 0;
        }
        let importe_impuesto = parseFloat(
          (item.importe - item.descuento).toFixed(2)
        );
        let impp = parseFloat(
          (importe_impuesto * parseFloat(el.cuota)).toFixed(2)
        );
        suma_impuesto_rete[el.clave] += parseFloat(impp.toFixed(2));

        let retencion : any = {
          Base: importe_impuesto,
          Impuesto: el.clave,
          TipoFactor: el.factor,
          TasaOCuota : el.cuota,
          Importe : impp.toFixed(2),
        }
        
        impuesto_incluido.Retenciones.push({
          Retencion: retencion
        });
      });

      item.Impuestos = impuesto_incluido;
    } else {
      delete item.Impuestos;
    }
    this.recalcular_impuesto();
  }

  logo;
  logo_sucursal;
  logo_empresa;
  asignarLogos(logos) {
    if (logos) {
      this.logo_sucursal = logos.sucursal;
      this.logo_empresa = logos.empresa;
      this.logo = this.logo_sucursal != "" ? this.logo_sucursal : this.logo_empresa;
    }
  }
}
